import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Youtube } from "@cinch-labs/design-system";
import { EventNames, TrackingEventTypes, useAnalytics } from "@cinch-nx/shared-analytics";
import { Wrapper } from "@cinch-nx/shared-ui";
import { formatVideoSchema } from "../json-ld-script";
import { JsonLdScript } from "../json-ld-script/json-ld-script";
import { Heading } from "../shared/heading/heading";
import { Text } from "../shared/text/text";
import styles from "./video.module.css";
import Head from "next/head";
export const Video = ({ videoId , title , thumbnail , description , ...rest })=>{
    const { trackEvent  } = useAnalytics();
    const videoStyles = {
        inner: styles.videoContainer,
        container: description && title ? styles.descriptionVideoMargin : styles.videoMargin
    };
    const sendVideoEvent = ()=>trackEvent({
            eventName: `Video click - ${window.location.pathname}`,
            type: TrackingEventTypes.ADOBE,
            data: {
                event: {
                    name: EventNames.click,
                    category: "video",
                    label: "thumbnail",
                    action: "latest video"
                }
            }
        });
    const schemaData = {
        videoId,
        title,
        thumbnail,
        description
    };
    return videoId ? /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Head, {
                children: /*#__PURE__*/ _jsx(JsonLdScript, {
                    schema: formatVideoSchema(schemaData),
                    tagId: "JargonPage"
                })
            }),
            title && /*#__PURE__*/ _jsx(Heading, {
                className: styles.heading,
                children: title
            }),
            description && /*#__PURE__*/ _jsx(Text, {
                children: description
            }),
            /*#__PURE__*/ _jsx(Wrapper, {
                isSlim: true,
                className: videoStyles,
                children: /*#__PURE__*/ _jsx(Youtube, {
                    videoId: videoId,
                    title: title || "",
                    className: styles.video,
                    customThumbnail: thumbnail === null || thumbnail === void 0 ? void 0 : thumbnail.filename,
                    buttonLabel: "Play video",
                    showNewPlayIcon: true,
                    onClick: sendVideoEvent,
                    ...rest
                })
            })
        ]
    }) : null;
};
export default Video;
